export const ADD_TO_MY_FANDOMS_OPTIMIZELY_VARIABLES = {
    EXPERIMENT_ENABLED: 'optimizely_enable_add_to_my_fandoms_experiment',
    EXPERIMENT_VARIANT: 'optimizely_experiment_add_to_my_fandoms_variant_name',
};
